import PropTypes from 'prop-types';

export const filtersValuesPropType = PropTypes.shape({
	architectsIds: PropTypes.arrayOf(PropTypes.number),
	locales: PropTypes.array,
	subordinationTypes: PropTypes.array,
	instituteTypes: PropTypes.array,
	architects: PropTypes.array,
	currentLocale: PropTypes.shape({
		title: PropTypes.string,
		name: PropTypes.string
	})
});
